import type { Contact } from '@indutrust/shared-model';
import { type } from '@ngrx/signals';
import { eventGroup } from '@ngrx/signals/events';
import type { CreateCompanyContactPayload } from '../company-contact-api-client.service';

/**
 * Workflow events for `POST /companies/{id}/create_contact`.
 *
 * Pattern B (custom workflow) — this is not a collection CRUD, it is an
 * explicit "create & attach" action against a specific company.
 *
 * @example
 * const dispatch = injectDispatch(companyCreateContactEvents);
 * dispatch.createContactRequested({ companyId: 3, contact: { ... } });
 */
export const companyCreateContactEvents = eventGroup({
  source: 'company.createContact',
  events: {
    createContactRequested: type<{
      companyId: number;
      contact: CreateCompanyContactPayload;
    }>(),
    createContactSucceeded: type<Contact>(),
    createContactFailed: type<{ error: string }>(),
  },
});
